import { render } from "./KhungChiTiet.vue?vue&type=template&id=85953b16&scoped=true&ts=true"
import script from "./KhungChiTiet.vue?vue&type=script&lang=ts"
export * from "./KhungChiTiet.vue?vue&type=script&lang=ts"

import "./KhungChiTiet.vue?vue&type=style&index=0&id=85953b16&scoped=true&lang=css"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/PHCN/ChiaGioThucHien/VLTL_FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85953b16"]])

export default __exports__